import { render, staticRenderFns } from "./ConvenioOutrasEntidades.vue?vue&type=template&id=f518d468"
import script from "./ConvenioOutrasEntidades.vue?vue&type=script&lang=js"
export * from "./ConvenioOutrasEntidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports